var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.assignmentComments),function(comment,i){return _c('EditorSingleComment',{key:`comment-${i}`,attrs:{"comment":comment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }